/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Contain information about occupancy
 * @export
 * @interface TravelineOccupancyInfoDto
 */
export interface TravelineOccupancyInfoDto {
    /**
     * Guests with main occupancy
     * @type {number}
     * @memberof TravelineOccupancyInfoDto
     */
    adultBed?: number;
    /**
     * Extra beds in the room
     * @type {number}
     * @memberof TravelineOccupancyInfoDto
     */
    extraBed?: number;
    /**
     * Child accommodation without bed
     * @type {number}
     * @memberof TravelineOccupancyInfoDto
     */
    childWithoutBed?: number;
}

/**
 * Check if a given object implements the TravelineOccupancyInfoDto interface.
 */
export function instanceOfTravelineOccupancyInfoDto(value: object): value is TravelineOccupancyInfoDto {
    return true;
}

export function TravelineOccupancyInfoDtoFromJSON(json: any): TravelineOccupancyInfoDto {
    return TravelineOccupancyInfoDtoFromJSONTyped(json, false);
}

export function TravelineOccupancyInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineOccupancyInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'adultBed': json['adultBed'] == null ? undefined : json['adultBed'],
        'extraBed': json['extraBed'] == null ? undefined : json['extraBed'],
        'childWithoutBed': json['childWithoutBed'] == null ? undefined : json['childWithoutBed'],
    };
}

  export function TravelineOccupancyInfoDtoToJSON(json: any): TravelineOccupancyInfoDto {
      return TravelineOccupancyInfoDtoToJSONTyped(json, false);
  }

  export function TravelineOccupancyInfoDtoToJSONTyped(value?: TravelineOccupancyInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adultBed': value['adultBed'],
        'extraBed': value['extraBed'],
        'childWithoutBed': value['childWithoutBed'],
    };
}

